'use strict';

function FileExportFilter () {

  /**
   * getResolution - converts point spacing to point density
   *
   * for information on point spacing, point density and conversion see: http://felix.rohrba.ch/en/2015/point-density-and-point-spacing/
   * This table shows the conversion for the most common resolutions
   *  -------------------------------------------------
   * |  Point Spacing (m)  |  Point Density (pts/m^2)  |
   * |        0.01         |           10000           |
   * |        0.05         |           400             |
   * |        0.2          |           25              |
   * |        0.7          |           2               |
   *  -------------------------------------------------
   *
   * @param {string} pointSpacing point spacing is equivalent to voxelSize in our pipeline
   * @return {number}             point density in whole numbers with points per square meter as unit
   */
  const getResolution = (pointSpacing) => {

    return Math.round(1 / Math.pow(pointSpacing, 2));
  };

  /**
   * getVoxelSize - converts a resolution string to a decimal number string
   *
   * voxel size represents the square unit of measurement used when inspecting the point cloud
   * voxel size can be thought of as the cloud's point spacing (the average distance between points in a cloud)
   *
   * Example:
   * res: '02' or 'full'
   * output: '0.2' or '0.05'
   *
   * Note: the original point clouds are labeled 'fullres' which is converted to '0.05', a close approximation
   *
   * @param {string}  res      the resolution of the file
   * @return {string}          decimal representation of voxel size
   */
  const getVoxelSize = (res) => {

    res = res.replace(/full/, '005').split('');
    res.splice(1,0,'.');

    return res.join('');
  };

  const getHumanReadableType = (file) => {

    const TYPES = {
      'orthomosaic_image': 'Orthomosaic',
      '3d_mesh': '3D Mesh',
      'dsm_image': 'Digital Surface Model',
      'dtm_image': 'Digital Terrain Model',
      '3d_point_cloud': 'Point Cloud',
      'decimated_point_cloud': 'Decimated Point Cloud',
      'gr_point_cloud': 'Ground Return Point Cloud',
      'custom_file': 'Custom File'
    };

    let type = '';

    if (typeof file === 'string') {
      type = TYPES[file];
    }
    else {
      type = `.${file.location.split('.').pop().toUpperCase()}`;

      // find any files that contain ('_') followed by (n digits OR the string 'full') and then the string ('res')
      const resolutionRegEx = /_(\d+|full)res/;
      const resolution = resolutionRegEx.exec(file.location);

      if (resolution) {
        if (file.type === 'gr_point_cloud' || file.type === 'decimated_point_cloud') {
          type = `${getResolution(getVoxelSize(resolution[1]))} pts/m\u00B2`;
        }
        else {
          type = `${type}\n(${getResolution(getVoxelSize(resolution[1]))} pts/m\u00B2)`;
        }
      }
      else if (file.type === 'dtm_image') {
        const isNotInterpolated = file.location.includes('dtm_gaps') ? 'Not i' : 'I';
        type = `${isNotInterpolated}nterpolated`;
      }
      else if (file.type === '3d_point_cloud') {
        type = '400 pts/m\u00B2';
      }
    }

    return type;
  };

  return (file) => {

    return getHumanReadableType(file);
  };
}

module.exports = FileExportFilter;



// WEBPACK FOOTER //
// ./src/app/manager/processing/filters/FileTypeFilter.js